export default () => ({
  alert: {},
  alerts: [],
  counter: 0
})
